import _createClass from "/Users/tannermarshall/Dev/figure53.dev/websites/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/Users/tannermarshall/Dev/figure53.dev/websites/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
/** Represent a week in a calendar month. */
export var CalendarWeek = /*#__PURE__*/_createClass(function CalendarWeek(weekNumber, days) {
  _classCallCheck(this, CalendarWeek);
  this.days = days;
  this.weekNumber = weekNumber;
});